import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { MovimientoEfectivoPolizaCredito, PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { PolizaCreditoListComponent } from './poliza-credito-list.component';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { consts } from '../../../consts';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActualSelected } from '../../../shared/utils';

@Component({
    selector: 'convfact-poliza-credito-movimiento-efectivo',
    templateUrl: './poliza-credito-dialog-movimiento-efectivo.component.html',
    styleUrls: ['./poliza-credito.component.css'],
    standalone: false
})
export class PolizaCreditoDialogMovimientoEfectivoComponent implements OnInit {

  public polizaCredito: PolizaCredito = this.data.polizaCredito;

  public tipoMovimientoEfectivoId: number = this.data.tipoMovimientoEfectivoId;

  public movimientoEfectivo: MovimientoEfectivoPolizaCredito = {
    uid: '',
    polizaCreditoId: '',
    tiposMovimientoEfectivoId: this.tipoMovimientoEfectivoId,
    efectivoId: '0',
    fecha: new Date(),
    comisiones: 0,
    concepto: '',
    importe: 0,
    efectivoName: '',
    activitiesUid: consts.EMPTY_GUID,
    activitiesName: '',
  };

  public tittle: string = 'Elemento';

  public saved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public efectivoList: Efectivo[] = [];

  private changesAtModal: boolean = false;

  public dataSource: MovimientoEfectivoPolizaCredito[] = [];

  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'importe', title: 'Importe', cell: (row) => `${row.importe}  `, class: (row) => `` },
    { field: 'efectivoName', title: 'Efectivo', cell: (row) => row.efectivoName ? `${row.efectivoName}` : '', class: (row) => `` },
  ];

  public activities: ActivityModel[] = [];

  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PolizaCreditoListComponent>,
    public polizaCreditoService: PolizaCreditoService,
    public efectivoService: EfectivoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
    private cdr: ChangeDetectorRef,
    private masterService: MasterService,
  ) { }

  public ngOnInit(): void {
  this.ready = false;

  Promise.all([
    this.activityService.getList(),
    this.efectivoService.list()
  ]).then(([activities, efectivo]) => {
    this.activities = activities;
    this.efectivoList = efectivo;
  });
  this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
        this.isProjectEnable = activity.isProject;
      });
  // Cargar proyectos y tipos de gasto, y luego getData()
  this.masterService.getProjects().subscribe(projects => {
    this.projects = projects;

    this.masterService.getExpenseProjectTypes().subscribe(expenses => {
      this.expenseProjectTypes = expenses;
      this.cdr.detectChanges();


      this.getData();
    });
  });

  // Ajustar título según tipo
  if (this.tipoMovimientoEfectivoId === 1) {
    this.tittle = "Reintegro de efectivo";
    this.movimientoEfectivo.concepto = 'Reintegro de efectivo';
  } else if (this.tipoMovimientoEfectivoId === 2) {
    this.tittle = "Ingreso de efectivo";
    this.movimientoEfectivo.concepto = 'Ingreso de efectivo';
  }
}


 public save(): void {
    this.movimientoEfectivo.polizaCreditoId = this.polizaCredito.uid;

    let noError: boolean = true;

    if (!this.movimientoEfectivo.fecha ||
        !this.movimientoEfectivo.concepto ||
        !this.movimientoEfectivo.importe ||
        !this.movimientoEfectivo.activitiesUid) {
      noError = false;
    }

    if (!noError) {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
      return;
    }

    // Aseguramos GUIDs válidos
    if (this.movimientoEfectivo.projectUid === null || this.movimientoEfectivo.projectUid === undefined) {
      this.movimientoEfectivo.projectUid = consts.EMPTY_GUID;
    }

    if (this.movimientoEfectivo.expenseProjectTypeUid === null || this.movimientoEfectivo.expenseProjectTypeUid === undefined) {
      this.movimientoEfectivo.expenseProjectTypeUid = consts.EMPTY_GUID;
    }

    this.changesAtModal = true;

    const request = this.isEditMode
      ? this.polizaCreditoService.movimientoEfectivoPolizaCreditoUpdate(this.movimientoEfectivo)
      : this.polizaCreditoService.movimientoEfectivoPolizaCreditoCreate(this.movimientoEfectivo);

    request
      .then(() => this.saved = true)
      .catch(() => this.displayInfo("Ha ocurrido un error al guardar el movimiento"));
  }

  public getData(): void {
    this.saved = false;
    this.ready = false;

    this.polizaCreditoService.movimientoEfectivoPolizaCreditoList(this.polizaCredito.uid, this.tipoMovimientoEfectivoId)
      .then(response => {
        this.dataSource = response;
        if (this.dataSource.length > 0) {
          this.list = true;
        }
        this.ready = true;
      })
      .catch(() => {
        this.ready = true;
      });
  }

  public delete(uidElement: string): void {
    this.changesAtModal = true;

    this.polizaCreditoService.movimientoEfectivoPolizaCreditoDelete(uidElement)
      .then(() => this.getData())
      .catch(() => this.displayInfo("Ha ocurrido un error al eliminar"));
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid === uidElement);
    if (!elementSearched) return;

    this.isEditMode = true;
    this.saved = false;
    this.movimientoEfectivo = { ...elementSearched };

    // Vincular selects
    if (elementSearched.projectUid) {
      const projectFound = this.projects.find(p => p.id === elementSearched.projectUid);
      this.movimientoEfectivo.projectUid = projectFound ? projectFound.id : null;
    }

    if (elementSearched.expenseProjectTypeUid) {
      const expenseFound = this.expenseProjectTypes.find(e => e.id === elementSearched.expenseProjectTypeUid);
      this.movimientoEfectivo.expenseProjectTypeUid = expenseFound ? expenseFound.id : null;
    }
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close(this.changesAtModal);
  }
  public trackByIndex(i: number) { return i; }

}
